<template>
  <el-dialog :title="dialogTitle" :visible.sync="open" :center="true" width="60%" @close="cancel"
    :close-on-click-modal="false">
    <div>
      <el-row>
        <el-col :span="6">
          <span>产品：{{ data.data?data.data[0].productName:'-' }}</span>
        </el-col>
        <el-col :span="6">
          <span>规格型号：{{data.data?data.data[0].specName:'-'}}</span>
        </el-col>
        <el-col :span="6">
          <span>批次号：{{data.data?data.data[0].batch:'-'}}</span>
        </el-col>
        <el-col :span="6">
          <span>序列号：{{data.data?data.data[0].serialNo:'-'}}</span>
        </el-col>
      </el-row>
      <div style="margin: 10px 0px">
        
        <el-dropdown @command="batchPrintChange"  style="margin: 10px 10px;">
          <el-button type="primary" size="small">
            批量打印<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1">RFID打印</el-dropdown-item>
            <el-dropdown-item command="2">普通打印</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button v-if="$listeners.tagCodeDelete && ($route.query.formMode==1||$route.query.formMode==2)" type="danger" class="btn" size="small" v-preventReClick @click="handleDelete">删除</el-button>
      </div>
      <el-table :data="tableData" border style="width: auto; margin: 10px 0px" stripe :header-cell-style="{ background: '#DDEBFF' }"
        @selection-change="handleSelectionChange" row-key="id" max-height="400">
        <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55"> </el-table-column>
        <el-table-column type="index" width="50" label="序号"> </el-table-column>
        <el-table-column prop="isRfidName" label="标签码类型" min-width="100"></el-table-column>
        <el-table-column prop="minTagCode" label="最小标签码/包标签码" min-width="190"></el-table-column>
        <el-table-column prop="itemTagCode" label="所属件装码" width="190"></el-table-column>
          <el-table-column  :label="$route.name == 'InventoryEdit'?'账面数量':'数量'" width="100">
            <template slot-scope="scope">
              {{  scope.row.number +`(${scope.row.minUnit})`}}
            </template>
          </el-table-column>
          <el-table-column v-if="$route.name == 'InventoryEdit'" label="实盘数量" width="100">
            <template slot-scope="scope">
              {{ (labelScanTagCodeIds?.includes(`${scope.row.id}`)?scope.row.number:0) +`(${scope.row.minUnit})`}}
            </template>
          </el-table-column>
        <el-table-column prop="tagCodeTypeName" label="标签类型" width="110"></el-table-column>
        <el-table-column prop="printTimes" label="打印次数" width="100"></el-table-column>
        <el-table-column fixed="right" prop="operation" label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="text" size="small" v-preventReClick @click="print(scope.row)" class="color-blue">RFID打印</el-button>
            <el-button type="text" size="small"  @click="print1(scope.row)" class="margin-left20 color-blue">普通打印</el-button>
            <el-button type="text" size="small" v-if="$route.query.formMode==1||$route.query.formMode==2" v-preventReClick @click="deleteEvt(scope.row)" class="color-blue">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>


<script>
import {
  GetTagCodePrintData,
  GetTagCodeRfidPrintData
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin";

export default {
  mixins: [GetDataMixin],
  data () {
    return {
      dialogTitle: '最小标签明细',
      tableData:[],
      batchPrintType:'',
    }
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: {}
    },
    labelScanTagCodeIds:{
      type:Array,
      default:() => []
    }
  },
  created(){
    this.tableData = JSON.parse(JSON.stringify(this.$props.data.data)) 
  },
  mounted () {
    this.rfidSocketApi.init(this.onmessage, this.onopen);
  },
  beforeDestroy () {
    this.rfidSocketApi.clearBingMethods();
  },
  methods: {
    onmessage (e) {
      // window.console.log("收到消息啦:" + e.data);
      var data = JSON.parse(e.data);
      if (data.Successful) {
        this.$my_message("打印成功", "success");
      } else {
        this.$my_message("打印失败：" + data.Message, "error");
      }
    },
    onopen () {
      console.log("连接成功了哦");
    },

    handleDelete() {
      // 使用 filter 过滤出不需要删除的数据，并同时收集需要删除的 codes
      const [newTableData, codes] = this.tableData.reduce(([tableData, codes], item) => {
        if (this.ids.includes(item.id)) {
          codes.push(item.minTagCode); // 收集需要删除的 codes
        } else {
          tableData.push(item); // 保留不需要删除的数据
        }
        return [tableData, codes];
      }, [[], []]);

      // 更新 tableData
      this.tableData = newTableData;
      // 输出 codes
      // 触发事件
      this.$emit('tagCodeDelete', codes);
    },
    deleteEvt (row) {
      this.$confirm('是否删除该标签？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let arrIds = [row.minTagCode]
        this.tableData.splice(this.tableData.indexOf(row), 1);
        this.$emit('tagCodeDelete', arrIds)
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    cancel () {      
      this.$emit('close');
    },
     //普通打印
    print1 (row) {
      return new Promise((resolve, reject) => {
        let data = {
          tagCode: row.minTagCode,
          isSingle:row.isRfid==1?1:0
        }
        return GetTagCodePrintData(data).then((res) => {
          var result = res.returnData
          this.$set(row,'printTimes',row.printTimes+1)
          var printData = this.printDataConvert(result.printData)
          this.sendPrintMessage(JSON.stringify(printData));
          resolve(res.returnData);
        });
      });
    },
    print (row, notRefresh) {
      console.log(row);
      
      return new Promise((resolve, reject) => {
        return GetTagCodeRfidPrintData({
          tagCode: row.minTagCode,
        }).then((res) => {
          var action = "PrintSingle";
          if (row.isRfid != 1) {
            action = "PrintPack";
          }
          
            if(this.system_setting.RFIDTempSite){
            this.$my_message("打印成功", "success");
               this.$set(row,'printTimes',row.printTimes+1)
                resolve(res.returnData);
                return
            }
          var data = {
            Action: action,
            Content: res.returnData,
          };
          this.$set(row,'printTimes',row.printTimes+1)
          this.rfidSocketApi.sendSock(data);
          resolve(res.returnData);
        });
      });
    },
    batchPrintChange (num) {
      this.batchPrintType = num
      if (!this.multipleSelection) {
        this.$my_message("请选择要打印的数据", "warning");
        return;
      }
 

      const map = new Map();
      for (let i = 0; i < this.multipleSelection.length; i++) {
        if ("minTagCode" in this.multipleSelection[i]) {
          this.multipleSelection[i].minTagCode = this.multipleSelection[i].minTagCode;
        }
      }
      this.newArr = this.multipleSelection.filter(
        (key) => !map.has(key.minTagCode) && map.set(key.no, 1)
      );

      this.printForeach(0);
    },

    printForeach (i) {
      if (i != this.newArr.length) {
        let notRefresh = true;
        if (i == this.newArr.length - 1) {
          notRefresh = false;
        }
        if(this.batchPrintType==1){
          this.print(this.newArr[i], notRefresh).then((res) => {
            i++;
            setTimeout(() => {
              this.printForeach(i);
            }, 1000);
          });
        }else{
          this.print1(this.newArr[i], notRefresh).then((res) => {
            i++;
            setTimeout(() => {
              this.printForeach(i);
            }, 1000);
          });
        }
      
      } else {
        // this.getData()
      }
    },
  }
}
</script>